import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import { PatientIDContext } from '../../../Contexts';
import '../../../../dist/assets/stylesheets/css/patients.css';
import { deletePatient, getPatients } from '../../../util/patientsApi';
import PatientTrialsTable from './PatientTrialsTable';
import logo from '../../logo.PNG';
import UpdatePatientModal from '../UpdatePatientModal';
import { Icon } from '@iconify/react';
import { useDispatch, useSelector } from 'react-redux';
import {fetchPatient, patientActions} from '../../../store/patient-slice'
import PatientInfoContainer from './PatientInfoContainer';
import {useHistory} from 'react-router-dom'
import { notificationActions } from '../../../store/notification-slice';
import {useParams} from 'react-router-dom'
import Spinner from '../../decorations/Spinner';
import ConfirmModal from '../../modals/ConfirmModal';
import { getReports, getTrials } from '../../../util/reportAPI';
import { compareTrialsByRecordedAt } from '../../../util/trialSort';
import PatientReportsTable from './PatientReportsTable';
import { useQuery } from '../../SharedHooks';
function PatientDashboard(props) {
    const dispatch=useDispatch()
    const history=useHistory()
    const {patientID}=useParams()
    const query=useQuery()
    // const [patientInfo,setPatientInfo]=useState(null)
    const patientInfo=useSelector(state=>state.patient.patientInfo)
    // const [patientInfo, setPatientInfo] = useState({
    //     patient_name:"",
    //     patient_condition: "",
    //     patient_notes: "" ,
    //     patient_id: "",
    // });
    // const { patient_name, patient_condition, patient_notes, patient_id, patient_email,patient_weight,patient_height,patient_phone } = patientInfo?patientInfo:null;
    const [activeTab,setActiveTab]=useState(query.get('activeTab')||'trials')
    const [showUpdateModal,setShowUpdateModal]=useState(false)
    const [patientTrials,setPatientTrials]=useState([])
    const [patientReports,setPatientReports]=useState([])
    useEffect(()=>{
        history.push('?activeTab='+activeTab)
    },[activeTab])
    useEffect(() => {
        // getPatients(patientID)
        //     .then(res => {
        //         setPatientInfo(res[0])
        //         // console.log(patientID)
        //         // window.testvar = res;
        //         // const patientInfo = res.filter(data => data.patient_id == patientID)[0];
        //         // console.log(patientInfo);
        //         // dispatch(patientActions.setPatient(res[0]))
        //     })
        dispatch(fetchPatient(patientID))
    }, []);
    useEffect(() => {
        getTrials(patientID).then((data) => {
          const res = Array.isArray(data && data.result) ? data.result : [];
          setPatientTrials(res.slice().sort((a, b) => compareTrialsByRecordedAt(a, b)));
        });
        getReports(patientID).then(res=>setPatientReports(res.data))
      }, [patientID]);
    const [confirmModal,setShowConfirmModal]=useState({
        show:false,
        acceptHandler:null,
    })
    const confirm=()=>{
        setShowConfirmModal({show:true,acceptHandler:deletePatientHandler,message:'Are you sure you want to delete this patient? This action cannot be undone.'})
    }
    const deletePatientHandler= async ()=>{
        try{
        await deletePatient(patientID)
        dispatch(notificationActions.setNotification({show:true,message:'Deleted patient successfully',status:'success'}))
        history.push('/patients')
        }
        catch(e){
            console.log(e)
            dispatch(notificationActions.setNotification({show:true,message:'Something wrong happened. Please try again.',status:'error'}))
        }
    }
    return(patientInfo?<div className="parent-container">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                <nav className="trial-breadcrumb" style={{ fontSize: '1.25rem', color: 'rgba(0,0,0,0.87)', display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Link to="/patients" className="trial-breadcrumb-link" style={{ color: 'rgba(0,0,0,0.87)', textDecoration: 'none', fontWeight: 500 }}>
                        Patients
                    </Link>
                    <span style={{ color: '#9ca3af' }}>{'>'}</span>
                    <span style={{ fontWeight: 600 }}>Dashboard</span>
                </nav>
                <button className='delete-button-trash' onClick={confirm}>
                    <Icon icon="ant-design:delete-outlined" />
                    Delete Patient
                </button>
            </div>
            <nav id="dashboard-button-container" className="container">
                {/* <Link to={`/record_patient/${patientID}`} className="blue-button">
                    <button className="blue-button">Record</button>
                </Link>
                <Link to={`/report_patient/${patientID}`} className="blue-button">
                    <button className="blue-button">Create Report</button>
                </Link>
                <Link to={`/review_patient/${patientID}/0`} className="blue-button">
                    <button className="blue-button">Review Trial</button>
                </Link>
                 */}
            </nav>
            {/* <button onClick={confirm}>Delete Patient</button> */}
            {confirmModal.show&&<ConfirmModal message={confirmModal.message} rejectHandler={()=>setShowConfirmModal({...confirmModal,show:false})} acceptHandler={confirmModal.acceptHandler} />}
            {patientInfo&&<PatientInfoContainer patientInfo={patientInfo}/>}
            <div style={{display:'flex',justifyContent:'end',marginTop:'20px'}}>
            <Link to={"/patients/report_patient/"+patientID}>
                <button className='report-btn'>
                    <Icon icon="mdi:report-box-plus-outline" />
                    Create Report</button>
                </Link>
                <Link to={"/patients/compare-trials/"+patientID}>
                <button className='report-btn'>
                <Icon icon="octicon:git-compare-24" />
                Compare Trials</button>
                </Link>

            </div>
            <div className='trials-reports-container'><span onClick={()=>setActiveTab('trials')} className={activeTab=='trials'&&'active'} id='trials'>Trials</span><span className={activeTab=='reports'&&'active'} id='reports' onClick={()=>setActiveTab('reports')}>Reports</span></div>
            {activeTab=='trials'&&<PatientIDContext.Provider value={patientID}>
                <PatientTrialsTable patientTrials={patientTrials}/>
            </PatientIDContext.Provider>}
            {activeTab=='reports'&&<PatientIDContext.Provider value={patientID}>
                <PatientReportsTable patientReports={patientReports}/>
            </PatientIDContext.Provider>}
            
        </div>
    :<Spinner/>)
}

export default PatientDashboard;
